/**
 * Utility functions for handling coordinates consistently across platforms
 */

// Try to detect Windows platform
const isWindowsPlatform = () => {
  try {
    return navigator.platform.indexOf('Win') > -1 || 
           navigator.userAgent.indexOf('Windows') > -1;
  } catch (e) {
    return false;
  }
};

/**
 * Safely normalizes coordinates to ensure they're always stored as numbers
 * regardless of input format and platform
 */
export function normalizeCoordinates(coordinates: any) {
  if (!coordinates) return null;
  
  try {
    // Ensure lat and lng exist
    if (coordinates.lat === undefined || coordinates.lng === undefined) {
      return null;
    }
    
    // Garantir que os valores sejam tratados como strings primeiro para prevenir problemas de tipo
    const latStr = String(coordinates.lat).replace(',', '.');
    const lngStr = String(coordinates.lng).replace(',', '.');
    
    // Parse strings to numbers with explicit base 10
    const lat = Number(latStr);
    const lng = Number(lngStr);
    
    // Validate numbers
    if (isNaN(lat) || isNaN(lng)) {
      return null;
    }
    
    // Create new object with explicitly typed numeric values
    const result = {
      lat: lat,
      lng: lng
    };
    
    return result;
  } catch (error) {
    return null;
  }
}

/**
 * Normalize location data from Google Places API
 */
export function normalizeLocationData(placeData: any) {
  if (!placeData) return null;
  
  const result = {
    placeId: placeData.placeId || placeData.place_id || '',
    name: placeData.name || '',
    address: placeData.address || placeData.formattedAddress || '',
    coordinates: normalizeCoordinates(placeData.coordinates || placeData.location),
    googleMapsUrl: placeData.googleMapsUrl || placeData.url || 
      (placeData.placeId ? 
        `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(placeData.name || 'Local')}&query_place_id=${placeData.placeId}` : ''),
    city: placeData.city || '',
    country: placeData.country || ''
  };
  
  return result;
} 